(() => {
  const drawer = document.getElementById('halo-cart-sidebar');
  if (!drawer || drawer.dataset.vermartReady) return;
  drawer.dataset.vermartReady = 'true';
  let wasOpen = false;
  let returnFocus;
  let quantityFocus;
  const visible = el => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const focusable = scope => Array.from(scope.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex="0"]')).filter(visible);
  const sync = () => {
    const open = document.body.classList.contains('cart-sidebar-show');
    drawer.setAttribute('aria-hidden', String(!open));
    if (open && !wasOpen) {
      returnFocus = document.activeElement;
      requestAnimationFrame(() => {
        if (document.body.classList.contains('cart-sidebar-show')) {
          drawer.querySelector('[data-close-cart-sidebar]')?.focus();
        }
      });
    } else if (!open && wasOpen && returnFocus?.isConnected) {
      returnFocus.focus();
    }
    wasOpen = open;
  };
  new MutationObserver(sync).observe(document.body, {attributes: true, attributeFilter: ['class']});
  drawer.addEventListener('click', event => {
    const button = event.target.closest('.cartTool-item');
    if (button) {
      const popup = drawer.querySelector('#' + button.dataset.popup);
      if (popup?.classList.contains('show')) {
        button.setAttribute('aria-expanded', 'true');
        focusable(popup)[0]?.focus();
      }
    }
    const qty = event.target.closest('.btn-quantity');
    if (qty) {
      quantityFocus = {line: qty.parentElement.querySelector('[data-line]')?.dataset.line, plus: qty.classList.contains('plus')};
    }
    if (event.target.closest('cart-cancel-popup,[data-update-note],[data-update-coupon]')) {
      const opener = drawer.querySelector('.cartTool-item[aria-expanded="true"]');
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    }
  });
  document.addEventListener('cart-update', () => {
    if (!wasOpen) {
      quantityFocus = null;
      return;
    }
    const input = quantityFocus && Array.from(drawer.querySelectorAll('[data-cart-quantity]')).find(el => el.dataset.line === quantityFocus.line);
    const target = input?.parentElement.querySelector(quantityFocus.plus ? '.plus' : '.minus');
    if (target) target.focus();
    else if (quantityFocus || document.activeElement === document.body || document.activeElement === null) {
      drawer.querySelector('[data-close-cart-sidebar]')?.focus();
    }
    quantityFocus = null;
  });
  drawer.addEventListener('keydown', event => {
    if (!wasOpen || document.body.matches('.edit-cart-show,.term-condition-show,.has-warning')) return;
    const popup = drawer.querySelector('.popup-toolDown.show');
    if (event.key === 'Escape') {
      event.preventDefault();
      if (popup) popup.querySelector('cart-cancel-popup button')?.click();
      else drawer.querySelector('[data-close-cart-sidebar]')?.click();
    }
    if (event.key === 'Tab') {
      const items = focusable(popup || drawer);
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    }
  });
  sync();
})();
